import * as React from "react";
import { Formik, Form } from "formik";
import styled from "styled-components";
import ArchiveSizeEstimate from "data-lake/components/ArchiveSizeEstimate";
import { Modal, Alert } from "components/bootstrap";
import { ModalSubmit } from "components/common";
import useUserDateTime from "hooks/useUserDateTime";
import { getRangeValidationErrors, getDefaultValues } from "data-lake/components/DataLakeActionModals/utils";
import useCurrentDataLakePlugin from "data-lake/preview/hooks/useCurrentDataLakePlugin";
import validateFieldFilters from "data-lake/logic/validateFieldFilters";
import useFieldTypes from "data-lake/hooks/useFieldTypes";
const MAX_FILTERS = 3;
const StyledModal = styled(Modal)`
  z-index: 1070;
`;
const DataLakeRetrievalActionForm = ({
  modalTitle,
  calculateEstimatedSize = true,
  defaultTimeRange = null,
  show,
  onSubmit,
  onHide,
  children,
  submitButtonText,
  hourOnly = false,
  dataLakeId,
  streamIds = void 0,
  defaultFieldFilters = [],
  defaultFieldOperator = "AND"
}) => {
  const { retrievalFormFieldsComponent: RetrievalFormFields } = useCurrentDataLakePlugin();
  const { inMemoryFields } = useFieldTypes();
  const { formatTime } = useUserDateTime();
  const validate = (values) => {
    const {
      nextTimeRange: { to, from },
      inclusionType,
      fieldFilters = [],
      operator
    } = values;
    let errors = getRangeValidationErrors(from, to);
    if (!inclusionType) {
      errors = { ...errors, inclusionType: "The Include Message field is required." };
    }
    const fieldFiltersErrors = validateFieldFilters(fieldFilters, operator, inMemoryFields, MAX_FILTERS);
    if (fieldFiltersErrors.length > 0) {
      errors = {
        ...errors,
        fieldFilters: fieldFiltersErrors
      };
    }
    return errors;
  };
  const handleSubmit = ({
    nextTimeRange: { from, to },
    wipeRestores,
    inclusionType,
    streamIds: streamIdList,
    fieldFilters,
    operator
  }) => {
    onSubmit({
      from,
      to,
      wipe_restores: wipeRestores,
      inclusion_type: inclusionType,
      data_lake_id: dataLakeId,
      stream_ids: streamIdList,
      field_filters: fieldFilters,
      operator
    });
  };
  return /* @__PURE__ */ React.createElement(StyledModal, { onHide: () => onHide(), show }, /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues: {
        ...getDefaultValues(
          formatTime,
          defaultTimeRange,
          dataLakeId,
          streamIds,
          defaultFieldFilters,
          defaultFieldOperator
        )
      },
      onSubmit: handleSubmit,
      validate,
      validateOnMount: true
    },
    ({ isSubmitting, isValidating, isValid, values }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(Modal.Body, null, children, /* @__PURE__ */ React.createElement(RetrievalFormFields, { hourOnly, submitButtonText }), calculateEstimatedSize && isValid && /* @__PURE__ */ React.createElement(
      ArchiveSizeEstimate,
      {
        estimateParams: {
          streamIds: values.streamIds,
          dataLakeId: values.dataLakeId,
          from: values.nextTimeRange.from,
          to: values.nextTimeRange.to,
          inclusionType: values.inclusionType,
          fieldFilters: values.fieldFilters,
          operator: values.operator
        }
      }
    ), !calculateEstimatedSize && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, "It is not possible to estimate the size of data retrieved from third-party sources. Please review and estimate the size from the source data before starting a large job.")), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        submitButtonText,
        submitLoadingText: "Submitting request...",
        onCancel: () => onHide(),
        disabledSubmit: isValidating || !isValid,
        isSubmitting
      }
    )))
  ));
};
export default DataLakeRetrievalActionForm;
